<template>
  <div class="scrollable-content--width">
    <div class="text-content">
      <p>
        As the Fiduciary for the Plan, ERISA requires that you operate your plan
        for the exclusive purpose of participants and beneficiaries. This report
        helps you improve the Retirement Outcomes for your participants for
        little or no cost to you as the employer. Also note, however, that by
        helping your employees retire on time or even early, your business could
        realize the following ancillary benefits:
      </p>
    </div>

    <section>
      <div class="section-header">
        <h2>Estimated Cost of Labor</h2>
      </div>

      <div class="section-content">
        <div class="big-graph-wrap">
          <div class="big-graph-unit">
            <p>
              If your employees cannot retire when they wish, they will continue
              to work. It is a fact that older workers make more money than
              younger workers, and while this is not necessarily detrimental to
              your business, it is important for you to understand that an older
              workforce will usually come with higher labor costs.
            </p>
          </div>
          <roe-double-horizontal-bar
            :data="[
              annualCostEstimation.current_labor,
              annualCostEstimation.labor_5year
            ]"
            :max-value="maxValue"
          ></roe-double-horizontal-bar>
        </div>
      </div>
    </section>

    <section>
      <div class="section-header">
        <h2>Cost of Employee Benefits</h2>
      </div>

      <div class="section-content">
        <div class="big-graph-wrap">
          <div class="big-graph-unit">
            <p>
              It is a fact that as employees age, the cost of medical and life
              insurance benefits increase. Thus, an employer who allows their
              employees to retire on time or even early will have lower
              long-term employee benefit costs.
            </p>
          </div>
          <roe-double-horizontal-bar
            :data="[
              annualCostEstimation.current_benefits,
              annualCostEstimation.benefits_5year
            ]"
            :max-value="maxValue"
          ></roe-double-horizontal-bar>
        </div>
      </div>
    </section>

    <section>
      <div class="section-header">
        <h2>Cost of Absenteeism</h2>
      </div>

      <div class="section-content">
        <div class="big-graph-wrap">
          <div class="big-graph-unit">
            <p>
              It is a fact that as employees age, the costs of absenteeism go up
              for a variety of reasons – many of which are related to the
              natural aging process. Thus, an employer who allows their
              employees to retire on time or even early will have lower
              long-term absenteeism costs.
            </p>
          </div>
          <roe-double-horizontal-bar
            :data="[
              annualCostEstimation.current_absenteeism,
              annualCostEstimation.absenteeism_5year
            ]"
            :max-value="maxValue"
          ></roe-double-horizontal-bar>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_ANNUAL_COST_ESTIMATION } from "@/store/actions.type";
import RoeDoubleHorizontalBar from "@/components/charts/DoubleHorizontalBar";
export default {
  name: "RoeReportBetterRetirementOutcomes",
  components: { RoeDoubleHorizontalBar },
  mounted() {
    this.fetchAnnualCostEstimation();
  },
  computed: {
    ...mapGetters(["annualCostEstimation"]),
    maxValue() {
      return Math.max(
        this.annualCostEstimation.current_labor,
        this.annualCostEstimation.labor_5year,
        this.annualCostEstimation.current_benefits,
        this.annualCostEstimation.benefits_5year,
        this.annualCostEstimation.current_absenteeism,
        this.annualCostEstimation.absenteeism_5year
      );
    }
  },
  methods: {
    fetchAnnualCostEstimation() {
      this.$store.dispatch(
        FETCH_ANNUAL_COST_ESTIMATION,
        this.$router.currentRoute.params.id
      );
    }
  }
};
</script>
